class FileUploadConfig {
    public static maxFileSize = 3072;
    public static generalMessages = {
    invalidFileName: "Por favor ingrese un nombre para el archivo",
        notFileSelected: "Por favor seleccione un archivo",
        fileExceedsSize: "El archivo seleccionado excede 3M por favor verifique"
    };
}

export { FileUploadConfig }